interface EmptyStateProps {
  title?: string;
  description?: string;
  onReset?: () => void;
  resetLabel?: string;
}

export default function EmptyState({
  title = "暂无匹配结果",
  description = "换个关键词或调整筛选条件后再试试。",
  onReset,
  resetLabel = "重置筛选",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-search-eye-line text-2xl" />
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-sm text-sm text-foreground-600">{description}</p>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-5 rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
        >
          {resetLabel}
        </button>
      )}
    </div>
  );
}